<template>
  <div>
    <template v-for="(doc_, p1) in doc">
      <v-dialog v-model="show_modal" persistent max-width="700px">
        <v-card>
          <v-card-title class="headline">Destinatarios para firmar</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="validForm" @submit.prevent="enviar_correos" lazy-validation>
              <template v-for="(destinatario_, index) in array_destinatarios">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      @blur="validarUsuario(destinatario_)" 
                      v-model="destinatario_.correo" 
                      type="email" 
                      :color="destinatario_.existe ? 'success' : 'info'"
                      :rules="emailRules" 
                      label="Correo electrónico" 
                      :append-outer-icon="destinatario_.existe ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                      required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-checkbox 
                      v-if="destinatario_.existe && doc_.usuario_es_duenio && !doc_.bloqueado"
                      v-model="destinatario_.firmar" :label="`¿solicitar firma?`">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-btn small color="danger" v-if="index > 0" @click="eliminar_destinatario(index)" style="margin-top: 20px;">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="cerrar_form"> Cerrar </v-btn>
            <v-btn  class="pull-left" :disabled="loading" color="info" @click="nuevo_destinatario"> Nuevo destinatario </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loading"
              :disabled="loading" 
              color="primary" 
              @click="enviar_correos(doc_, p1)" 
              type="submit"> Enviar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
  		props: ['show_modal', 'doc'],
  		data: function() {
  		  return {
          loading: null,
  		  	documentos_firmados: [],
  		  	array_destinatarios: [{ "correo": "", "nombre": "", "apellido": "", "existe" : null, "firmar": false }],
  	      validForm: true,
  	      emailRules: [
  	        v => !!v || 'E-mail is required',
  	        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
  	      ],
  		  };
  		},
    	computed: {
    	},
    	mounted() {
        //console.log(this.$route.name);
    	},
    	methods: {
  	  	nuevo_destinatario(){
  	  		this.array_destinatarios.push({ "correo": "", "nombre": "", "apellido": "", "existe" : null, "firmar": false });
  	  	},
  	  	eliminar_destinatario(index){
  	  		this.array_destinatarios.splice(index, 1);
  	  	},
  	  	cerrar_form(){
  	  		this.array_destinatarios=[{ "correo": "", "nombre": "", "apellido": "", "existe" : null, "firmar": false }];
          this.$emit('childToParent', {'modal': false, 'data': [] });
  	  	},
  	  	enviar_correos(doc, index)
  	  	{
  	  		var _thisEC = this;
  	  		if(this.$refs.form.length == 1){
  	  			index = 0;
  	  		}
  
  	  		if (this.$refs.form[index].validate())
  	  		{
            this.loading = true;
  					let paqueteData = { 
  				    "to":"",
  				    "from":"noreply@infile.com.gt",
  				    "subject": doc.nombre_archivo,
  				    "plainTextContent": "Adjunto documento: " + doc.nombre_archivo,
  				    "htmlContent":"<p>Estimado usuario: <br /><br /> Adjunto copia del documento <strong>" +doc.nombre_archivo+"</strong>, enviado por: "+this.$store.state.user.email+"</p><p><small>Correo enviado por el sistema Infile Sign.</small></p>.",
  				    "DocumentoId":Number(doc.id),
  						"lista_destinatarios": this.array_destinatarios
  					}
  	        let postEmail = axios.post('Mail', paqueteData,  { 'headers': this.$store.state.user.headers })
  	        return postEmail.then((callback) => 
  	        {
  	        	if(callback.status == 200){
                this.$emit('childToParent', {'modal': false, 'data': this.array_destinatarios });
                this.$store.dispatch('SHOW_ERROR', {show: true, type: 'info', text: 'Enviado correctamente' });
  	        		this.array_destinatarios=[{ "correo": "", "nombre": "", "apellido": "", "existe" : null, "firmar": false }];
  	        	} else {
                this.$emit('childToParent', {'modal': true, 'data': [] });
  	        	}
              this.loading = false;
  	        }).catch((error) => {
  	        	console.log(error.response.data);
              this.$emit('childToParent', {'modal': true, 'data': [] });
  	        });
  	  		} else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Llenar todos los campos.' });
  	  		}
  	  	},
  	  	validarUsuario(user_){
  	  		console.log("validar correo");
  				let getUser = axios.get('InfoUsuario/existe?correo='+user_.correo, { 'headers': this.$store.state.user.headers })
  				return getUser.then((callback) => 
  				{
  					//console.log(callback.data);
  				  if (callback.status == 200) {
  						user_.existe = true;
  				  } 
  				}).catch((error) => {
  				  console.log(error.response);
  				  user_.existe = false;
  				  user_.firmar = false;
  				});
  	  	},
    	},
  };
</script>